import z from "zod";
import { client } from "../client";
import type {
	CommandEarmoldTypesStats,
	CommandCenterStats,
	StatsFilterProps,
	CommandTreatmentTimeStats,
} from "../types/stats.types";

export const fetchCommandStatsStatus = async (filters: StatsFilterProps) => {
	const params = new URLSearchParams();
	if (filters.date) {
		params.append("date", filters.date?.toISOString());
	}
	const response = await client.get<Promise<{ [key: string]: number }>>(
		`stats/commands/status`,
		{ params },
	);
	return response.data;
};

export const fetchCommandStatsStatusHalted = async (
	filters: StatsFilterProps,
) => {
	const params = new URLSearchParams();
	if (filters.date) {
		params.append("date", filters.date?.toISOString());
	}
	const response = await client.get<Promise<{ [key: string]: number }>>(
		`stats/commands/status/halted`,
		{ params },
	);
	return response.data;
};

export const fetchCommandTreatmentTimeStatus = async (
	filters: StatsFilterProps,
) => {
	const params = new URLSearchParams();
	if (filters.date) {
		params.append("date", filters.date?.toISOString());
	}
	if (filters.interval) {
		params.append("interval", filters.interval);
	}
	if (filters.enterprises && filters.enterprises.length) {
		params.append("enterprises", filters.enterprises.join(","));
	}
	if (filters.centers && filters.centers.length) {
		params.append("centers", filters.centers.join(","));
	}
	const response = await client.get<
		Promise<{ [key: string]: CommandTreatmentTimeStats }>
	>(`stats/commands/treatment-time`, { params });
	return response.data;
};

export const fetchCommandTypesStatus = async (filters: StatsFilterProps) => {
	const params = new URLSearchParams();
	if (filters.date) {
		params.append("date", filters.date?.toISOString());
	}
	const response = await client.get<Promise<{ [key: string]: number }>>(
		`stats/commands/types`,
		{ params },
	);
	return response.data;
};

export const fetchCommandEarmoldTypesStatus = async (
	filters: StatsFilterProps,
) => {
	const params = new URLSearchParams();
	if (filters.date) {
		params.append("date", filters.date?.toISOString());
	}
	const response = await client.get<Promise<CommandEarmoldTypesStats[]>>(
		`stats/commands/earmold/types`,
		{ params },
	);
	return response.data;
};

export const fetchTicketTypesStatus = async (filters: StatsFilterProps) => {
	const params = new URLSearchParams();
	if (filters.date) {
		params.append("date", filters.date?.toISOString());
	}
	const response = await client.get<
		Promise<{ label: string; value: number }[]>
	>(`stats/tickets/types`, { params });
	return response.data;
};

export const fetchCommandStatsCenters = async (filters: StatsFilterProps) => {
	const params = new URLSearchParams();
	if (filters.date) {
		params.append("date", filters.date?.toISOString());
	}
	const response = await client.get<Promise<CommandCenterStats[]>>(
		`stats/commands/centers`,
		{ params },
	);
	return response.data;
};

const CommandStatsSchema = z.object({
	notifications: z.object({
		total: z.coerce.number().min(0),
		unread: z.coerce.number().min(0),
	}),
});

export const fetchCommandStats = async (filters: {
	command_id: string | number;
}) => {
	const response = await client.get(`stats/commands/${filters.command_id}`);
	return CommandStatsSchema.parse(response.data);
};
